import React, { useState } from "react";
import { BiSort } from "react-icons/bi";
import { CiFilter } from "react-icons/ci";
import { format } from "date-fns";
import { FaFlag, FaEdit, FaFacebook, FaInstagram, FaWhatsapp, FaUsers, FaUser } from "react-icons/fa";
import { IoMdMail } from "react-icons/io";
import { RiFilterOffFill } from "react-icons/ri";
import { toast } from "react-toastify";
import { IoSearch, IoMailUnread } from "react-icons/io5";
import { MdGroups } from "react-icons/md";

// Modal Component to show the flag data, updated design based on the image
const ModalMain = ({ isOpen, onClose, flags, setFilterFlagId }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-75 z-50">
      <div className="bg-white p-6 rounded-lg shadow-lg max-w-md w-full">
        <div className="flex justify-between items-center mb-5">
          <h3 className="text-lg font-bold mt-2">Flag List</h3>
          <button
            className="text-4xl text-red-500 hover:text-blue-700"
            onClick={onClose}
            aria-label="Close"
            title="Close"
          >
            &times;
          </button>
        </div>
        <div className="max-h-[70vh] overflow-auto">
          <ul className="space-y-2">
            {flags.map((flag, index) => (
              <li
                key={index}
                className="flex items-center cursor-pointer hover:bg-gray-200"
                onClick={() => {
                  setFilterFlagId(flag.FlagID);
                  onClose();
                }}
              >
                {/* Flag Color */}
                <span
                  className="inline-block w-4 h-4 rounded-full mr-2"
                  style={{ backgroundColor: flag.FlagColorCode }}
                />

                {/* Flag Name */}
                <span>{flag.FlagName}</span>
              </li>
            ))}
          </ul>
        </div>

        {/* Action buttons */}
        <div className="mt-6 flex justify-end gap-2">
          <button
            onClick={onClose}
            className="bg-gray-300 text-black px-4 py-2 rounded hover:bg-gray-400"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

const ModalChatWise = ({
  isOpen,
  onClose,
  flags,
  setFlags,
  setIsAddNewFlagModalOpen,
  customerMobileNo,
  handleFlagClick,
  setEditFlagName,
  setEditFlagColor,
  setEditFlagID,
}) => {
  if (!isOpen) return null;

  // Function to handle checkbox toggle
  const handleCheckboxChange = (index) => {
    const updatedFlags = flags.map((flag, flagIndex) => {
      if (flagIndex === index) {
        return { ...flag, FlagCheckbox: flag.FlagCheckbox === "1" ? "0" : "1" };
      }
      return flag;
    });

    setFlags(updatedFlags);
  };

  const ApiBaseURL = process.env.REACT_APP_GROUP_URL;
  const token = localStorage.getItem("authToken");
  const isAgent = localStorage.getItem("isAgent") === "true";

  // Function to handle API call on Save
  const handleSaveFlags = async () => {
    const selectedFlags = flags
      .filter((flag) => flag.FlagCheckbox === "1")
      .map((flag) => flag.FlagID);

    const payload = {
      flagID: selectedFlags,
      customerMobileNo: customerMobileNo,
    };

    try {
      const response = await fetch(`${ApiBaseURL}WhatsappGroup/SetFlagCustomer`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(payload),
      });

      // console.log("Flags updated successfully:", response);
      onClose();
    } catch (error) {
      onClose();
      console.error("Error updating flags:", error);
    }
  };

  const handleEditLabel = async (index) => {
    const updatedFlag = flags[index];
    setEditFlagName(updatedFlag.FlagName);
    setEditFlagColor(updatedFlag.FlagColorCode);
    setEditFlagID(updatedFlag.FlagID);
    setIsAddNewFlagModalOpen(true);
  };

  // Function to handle API call on Delete
  const handleDeleteFlags = async () => {
    const selectedFlags = flags
      .filter((flag) => flag.FlagCheckbox === "1")
      .map((flag) => flag.FlagID);

    const payload = {
      flagID: selectedFlags,
      CustomerMobileNo: "",
    };

    try {
      const response = await fetch(`${ApiBaseURL}WhatsappGroup/DeleteSaveflag`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(payload),
      });
      handleFlagClick(customerMobileNo);
    } catch (error) {
      console.error("Error deleting flags:", error);
    }
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-75 z-50">
      <div className="bg-white p-6 rounded-lg shadow-lg max-w-md w-full">
        <div className="flex justify-between items-center mb-5">
          <h3 className="text-lg font-bold mb-4">Flag List</h3>
          <button
            className="text-4xl text-red-500 hover:text-blue-700"
            onClick={onClose}
            aria-label="Close"
            title="Close"
          >
            &times;
          </button>
        </div>
        <div className="max-h-[70vh] overflow-auto">
          <table className="min-w-full border-collapse">
            <thead>
              <tr>
                <th className="border-b-2 border-gray-300 px-4 py-2 text-left">
                  Flag
                </th>
                <th className="border-b-2 border-gray-300 px-4 py-2 text-left">
                  Name
                </th>
                <th className="border-b-2 border-gray-300 px-4 py-2 text-left">
                  Select
                </th>
              </tr>
            </thead>
            <tbody>
              {flags.map((flag, index) => (
                <tr key={index} className="hover:bg-gray-100">
                  <td className="border-b border-gray-200 px-4 py-2">
                    <span
                      className="inline-block w-4 h-4 rounded-full"
                      style={{ backgroundColor: flag.FlagColorCode }}
                    />
                  </td>
                  <td className="border-b border-gray-200 px-4 py-2">
                    {flag.FlagName}
                  </td>
                  <td className="flex gap-3 items-center border-b border-gray-200 px-4 py-2">
                    <input
                      type="checkbox"
                      checked={flag.FlagCheckbox === "1"}
                      onChange={() => handleCheckboxChange(index)}
                    />
                    <FaEdit
                      className="text-[#2c678d] mb-1 cursor-pointer"
                      size={20}
                      onClick={() => handleEditLabel(index)}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="mt-6 flex justify-end gap-2">
          <button
            onClick={() => setIsAddNewFlagModalOpen(true)}
            className="bg-purple-500 text-white px-4 py-2 rounded hover:bg-purple-600"
          >
            Add New
          </button>
          <button
            onClick={handleSaveFlags}
            className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
          >
            Save
          </button>
          <button
            onClick={handleDeleteFlags}
            className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600"
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  );
};

// ModalAddNewFlag component with color picker and label input
const ModalAddNewFlag = ({
  isOpen,
  onClose,
  onSave,
  setFlagColor,
  flagColor,
  setLabelName,
  labelName,
  EditFlagID,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-75 z-50">
      <div className="bg-white p-6 rounded-lg shadow-lg max-w-md w-full">
        <h3 className="text-lg font-bold mb-4">Add New Flag</h3>

        {/* Label Name Input */}
        <div className="mb-4">
          <label
            className="block text-gray-700 text-sm font-bold mb-2"
            htmlFor="labelName"
          >
            Label Name
          </label>
          <input
            type="text"
            id="labelName"
            value={labelName}
            onChange={(e) => setLabelName(e.target.value)}
            maxLength={50}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg"
            placeholder="Enter label name"
          />
        </div>

        {/* Color Picker */}
        <div className="mb-4">
          <label className="block text-gray-700 text-sm font-bold mb-2">
            Choose Color
          </label>
          <input
            type="color"
            value={flagColor}
            onChange={(e) => setFlagColor(e.target.value)}
            className="w-full h-10 p-1 border border-gray-300 rounded-lg"
          />
        </div>

        {/* Action buttons */}
        <div className="flex justify-end gap-2">
          <button
            onClick={() => onSave(labelName, flagColor, EditFlagID)}
            className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
          >
            {EditFlagID ? "Update" : "Save"}
          </button>
          <button
            onClick={onClose}
            className="bg-gray-300 text-black px-4 py-2 rounded hover:bg-gray-400"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

const ChatList = ({
  chats,
  setActiveChat,
  setSearchTerm,
  setShowUnread,
  setShowSendingDiv,
  setFilterFlagId,
  FilterFlagId,
  setIsAgentToAgent,
  activeChat
}) => {
  const ApiBaseURL = process.env.REACT_APP_GROUP_URL;
  const token = localStorage.getItem("authToken");
  const isAgent = localStorage.getItem("isAgent") === "true";


  const [sortOption, setSortOption] = useState("date"); // Default sorting by date
  const [sortOrder, setSortOrder] = useState("asc"); // Default sorting order descending
  const [selectedReceivers, setSelectedReceivers] = useState([]);

  // Modal state for flags
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedChatNumber, setSelectedChatNumber] = useState(null);

  const [isFlagModalOpen, setIsFlagModalOpen] = useState(false);
  const [flags, setFlags] = useState([]);
  const [isAddNewFlagModalOpen, setIsAddNewFlagModalOpen] = useState(false);

  const [flagColor, setFlagColor] = useState("#563D7C");
  const [labelName, setLabelName] = useState("");
  const [EditFlagID, setEditFlagID] = useState(0);

  const [isAgentFilterOpen, setIsAgentFilterOpen] = useState(false);
  const [selectedAgentFilter, setSelectedAgentFilter] = useState([]);
  const [agents, setAgents] = useState([]);


  // Handle filter icon click to open the modal and fetch API data
  const handleFilterClick = async () => {
    try {

      setIsModalOpen(true);
      const response = await fetch(
        `${ApiBaseURL}WhatsappGroup/GetFlag?CustomerMobNo=`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json"
          },
        }
      );

      const data = await response.json();
      setFlags(data?.Flags || []); // Set the flags from the response
    } catch (error) {
      console.error("Error fetching flag data:", error);
    }
  };

  const handleFlagClick = async (chatNumber) => {
    try {
      setSelectedChatNumber(chatNumber);
      setIsFlagModalOpen(true);

      const response = await fetch(
        `${ApiBaseURL}WhatsappGroup/GetFlag?CustomerMobNo=${chatNumber}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json"
          },
        }
      );

      const data = await response.json();
      setFlags(data.Flags || []);
    } catch (error) {
      console.error("Error fetching flag data:", error);
    }
  };

  // Handle UnRead icon Unread Message Set call API
  const handleUnReadClick = async (id) => {
    setActiveChat("");
    const response = await fetch(
      `${ApiBaseURL}WhatsappGroup/UpdateUnReadMessage?mobile=${id}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json"
        },
      }
    );

    if (!response.ok) {
      // Handle error response
      console.error("Error updating unread messages:", response.statusText);
      return;
    }

    const data = await response.json();
    // console.log("Response data:", data);
  };

  // Handle Session End icon Session End call API
  const handleSessionEndChat = async (SessionId, MobileNo) => {
    setActiveChat("");
    const response = await fetch(
      `${ApiBaseURL}WhatsappGroup/ChatClose?SessionId=${SessionId}&CustomerNumber=${MobileNo}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json"
        },
      }
    );

    if (!response.ok) {
      // Handle error response
      console.error("Error updating unread messages:", response.statusText);
      return;
    }

    const data = await response.json();
  };

  // Sort chats by date, defaulting to descending order
  const sortedChats = [...chats].sort((a, b) => {
    let result = 0;
    if (sortOption === "date") {
      result = new Date(b.lastMessageTime) - new Date(a.lastMessageTime);
    } else if (sortOption === "name") {
      result = a.name.localeCompare(b.name);
    } else if (sortOption === "unread") {
      result = b.unread - a.unread;
    }
    return sortOrder === "asc" ? result : -result;
  });

  // Filter chats based on selected tab
  const getAgentFilter = (chat) => {
    if (!isAgent && selectedAgentFilter.length > 0) {
      const agentDisplayName = chat?.AgentName
        ? chat.AgentName.split(" ")[0]
        : null;
      return agentDisplayName ? selectedAgentFilter.includes(agentDisplayName) : false;
    }
    return true;
  };

  const filteredChats = sortedChats.filter(chat => !chat.active && getAgentFilter(chat));

  const handleSortChange = (option) => {
    if (sortOption === option) {
      setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    } else {
      setSortOption(option);
      setSortOrder("asc");
    }
  };

  const handleSelectedReceivers = ({ id, number }) => {
    const isExist = selectedReceivers.find((item) => item.number === number);
    setSelectedReceivers(
      isExist
        ? selectedReceivers.filter((num) => num.number !== number)
        : [...selectedReceivers, { id, number }]
    );
  };

  const handleActiveChat = (chat) => {
    setActiveChat("");
    setActiveChat(chat);
    localStorage.setItem("StartLoaderChatWindow", "1");
  };

  const handleSearchTerm = (event) => {
    const search = event.target.value;
    setSearchTerm(search);
  };

  const handleSaveNewFlag = async (labelName, flagColor, EditFlagId) => {
    if (!labelName) {
      toast.error("Flag name is required.");
      return;
    }

    // Define the API URL with query parameters
    const encodedLabelName = encodeURIComponent(labelName);
    const encodedFlagColor = encodeURIComponent(flagColor);
    try {
      let response;
      if (EditFlagId) {
        // If EditFlagId is provided, make the API call to update the flag
        response = await fetch(
          `${ApiBaseURL}WhatsappGroup/UpdateSaveFlag?labelname=${encodedLabelName}&lblcolorcode=${encodedFlagColor}&FlagID=${EditFlagId}`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
          }
        );
      } else {
        // Otherwise, make the API call to add a new flag
        response = await fetch(
          `${ApiBaseURL}WhatsappGroup/AddNewFlag?LabelName=${encodedLabelName}&LblColorCode=${encodedFlagColor}`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
          }
        );
      }

      // Check if the request was successful
      if (response.ok) {
        setIsAddNewFlagModalOpen(false);
        setFlagColor("#563D7C");
        setLabelName("");
        setEditFlagID(0);
        // Call handleFlagClick with the selected chat number
        if (selectedChatNumber) {
          await handleFlagClick(selectedChatNumber);
        } else {
          console.error("Selected chat number is not set.");
        }
      } else {
        console.error("Failed to add new flag:", response.statusText);
      }
    } catch (error) {
      console.error("Error adding new flag:", error);
    }
  };

  return (
    <div className="w-full md:w-full p-2 md:p-4 flex flex-col bg-white shadow-lg h-full max-h-90 overflow-hidden">
      <div className="flex flex-col mb-0">
        <div className="flex items-center mb-2">
          <div className="w-full flex flex-col items-end gap-2">
            <div className="w-full relative flex-grow">
              <IoSearch size={28} className="absolute inset-y-0 top-1/2 -translate-y-1/2 left-0 flex items-center pl-3 pointer-events-none text-gray-500" />
              <input
                type="search"
                className="block w-full p-2 pl-8 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-[#2c678d] focus:border-[#2c678d]"
                placeholder="Search..."
                onChange={handleSearchTerm}
                required
              />
            </div>
          </div>

          {FilterFlagId === "" ? (
            <CiFilter
              className="text-gray-500 ml-1 cursor-pointer"
              onClick={handleFilterClick}
              title="Filter Flag"
              size={26}
            />
          ) : (
            <RiFilterOffFill
              className="text-gray-500 ml-1 cursor-pointer"
              onClick={() => setFilterFlagId("")}
              title="Cancel Flag Filter"
              size={26}
            />
          )}
          <BiSort
            className="text-gray-500 ml-1 cursor-pointer"
            onClick={() => handleSortChange("date")}
            title="Sort by Date"
            size={26}
          />

          <input
            title="Show Unread" id="default-checkbox" type="checkbox"
            className="w-4 h-4 text-[#2c678d] bg-gray-100 border-gray-300 rounded focus:ring-[#2c678d] cursor-pointer ml-2"
            onChange={(e) => setShowUnread(e.target.checked)}
          />
          <span title="Unread" className="ml-2 text-sm">{isAgent ? "Unread" : <IoMailUnread className="text-gray-500" size={20} />}</span>
        </div>
      </div>
      <div className="flex-grow overflow-y-scroll">
        <div className="grid grid-cols-1 gap-2">
          {filteredChats.map((chat, i) => {
            const isSelected = selectedReceivers.find(
              (item) => item.number === chat.number
            );
            const lastMessageText =
              chat.messages.length > 0
                ? chat.messages[chat.messages.length - 1].text
                : "No messages";
            return (
              <div className="flex align-center gap-2" key={i}>
                <div key={chat.id} onClick={() => handleActiveChat(chat)}
                  className={`p-1 px-2 border rounded-lg ${chat.msgFrom === "i" ? "hover:bg-[#fff1f1]" : chat.msgFrom === "w" ? "hover:bg-[#e7f9f1]" : chat.msgFrom === "f" ? "hover:bg-[#eaeafe]" : "bg-gray-100"} cursor-pointer w-full shadow ${chat.number === activeChat?.number ? `${chat.msgFrom === "i" ? "bg-[#fff1f1]" : chat.msgFrom === "w" ? "bg-[#e7f9f1]" : chat.msgFrom === "f" ? "bg-[#eaeafe]" : "bg-gray-100"}` : `${chat.msgFrom === "i" ? "bg-[#fff9f9]" : chat.msgFrom === "w" ? "bg-[#ecfff7]" : chat.msgFrom === "f" ? "bg-[#f7f7ff]" : "bg-gray-100"}`
                    }`}>
                  <div className="flex justify-between items-center">
                    <div className="w-full gap-2">
                      <div className="flex justify-between">
                        <div className="w-full">
                          <div className="flex gap-1">
                            <div className="profile-icon p-1 flex items-center justify-center">
                              <MdGroups size={20} className="mt-1" />
                            </div>
                            <div className="flex flex-col">
                              <span style={{ fontWeight: 'bold', fontSize: '0.875rem', display: 'flex', alignItems: 'center', gap: '0.25rem' }}>
                                {/* <FaSquareInstagram style={{ color: 'red' }} /> */}
                                {chat.name}
                              </span>
                              {!chat.isGroup && (
                                <span className="text-gray-500 text-xs">
                                  ({chat.number})
                                </span>
                              )}
                            </div>
                          </div>
                          <div className="flex justify-between">
                            <div className="text-sm text-gray-600 mt-0 pt-0 mb-0 pb-0">
                              {lastMessageText}
                            </div>
                            {chat.AgentName && (
                              <div className="text-xs text-gray-600 p-2 py-1 bg-green-400 rounded-lg text-white">
                                {chat.AgentName}
                              </div>
                            )}
                          </div>
                        </div>
                        {/* Date and Time */}
                        <div className="flex flex-col justify-start align-end">
                          <div className="flex gap-2 text-small min-w-max text-right text-gray-500 mt-1 mb-0 px-1">
                            {chat.lastMessageTime &&
                              format(
                                new Date(chat.lastMessageTime),
                                "dd/MM/yyyy h:mm:ss a"
                              )}
                            {chat.msgFrom === "i" ? (<FaInstagram size={24} className="text-[#ff3034]" />) : chat.msgFrom === "w" ? (<FaWhatsapp size={24} className="text-green-500" />) : chat.msgFrom === "f" ? (<FaFacebook size={24} className="text-blue-500" />) : null}
                          </div>
                          <div className="flex align-center justify-end gap-2 p-1 mt-1">
                            {!isAgent && (
                              <>
                                <FaFlag
                                  className="cursor-pointer"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleFlagClick(chat.number);
                                  }}
                                  title="Set Flag"
                                />
                                <IoMdMail
                                  className="cursor-pointer"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleUnReadClick(chat.groupId);
                                  }}
                                  title="Mark Unread"
                                />
                                {chat.unread > 0 ? (
                                  <div className="flex items-center text-green-500">
                                    <div className={`bg-green-400 min-h-min min-w-6 ${chat.unread < 999 ? "aspect-square" : ''} rounded-full flex justify-center align-center p-1 ml-1`}>
                                      <p className="text-xs md:text-xs flex items-center text-white">
                                        {chat.unread < 999 ? chat.unread : "999+"}
                                      </p>
                                    </div>
                                  </div>
                                ) : (
                                  chat.MarkUnread > 0 && (
                                    <div className="flex items-center text-green-500">
                                      <div className="bg-green-400 min-h-min min-w-6 aspect-square rounded-full flex justify-center align-center p-1 ml-1"></div>
                                    </div>
                                  )
                                )}
                              </>
                            )}
                          </div>
                        </div>
                      </div>
                      {!isAgent && chat.flags && chat.flags.length > 0 && (
                        <div className="flex gap-1 mt-1 tags">
                          {chat.flags.map((flag, flagIndex) => (
                            <p
                              key={flagIndex}
                              style={{ backgroundColor: flag.flagColor }}
                              className="min-w-12 p-1 rounded-full flex justify-center mr-1 text-xs text-white"
                            >
                              {flag.flagName}
                            </p>
                          ))}
                        </div>
                      )}
                    </div>

                    {/* {chat.unread > 0 ? (
                      <div className="flex items-center text-green-500">
                        <div className="bg-green-400 min-h-min min-w-6 aspect-square rounded-full flex justify-center align-center p-1 ml-1">
                          <p className="text-xs md:text-xs text-white">
                            {chat.unread}
                          </p>
                        </div>
                      </div>
                    ) : (
                      chat.MarkUnread > 0 && (
                        <div className="flex items-center text-green-500">
                          <div className="bg-green-400 min-h-min min-w-6 aspect-square rounded-full flex justify-center align-center p-1 ml-1"></div>
                        </div>
                      )
                    )} */}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
      {/* Flag Modal */}
      <ModalMain
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        flags={flags}
        setFilterFlagId={setFilterFlagId}
      />
      {/* Flag Modal for selected chat */}
      <ModalChatWise
        isOpen={isFlagModalOpen}
        onClose={() => setIsFlagModalOpen(false)}
        flags={flags}
        setFlags={setFlags}
        setIsAddNewFlagModalOpen={setIsAddNewFlagModalOpen}
        customerMobileNo={selectedChatNumber}
        handleFlagClick={handleFlagClick}
        setEditFlagName={setLabelName}
        setEditFlagColor={setFlagColor}
        setEditFlagID={setEditFlagID}
      />

      {/* Modal for adding a new flag */}
      <ModalAddNewFlag
        isOpen={isAddNewFlagModalOpen}
        onClose={() => setIsAddNewFlagModalOpen(false)}
        onSave={handleSaveNewFlag}
        setFlagColor={setFlagColor}
        flagColor={flagColor}
        setLabelName={setLabelName}
        labelName={labelName}
        EditFlagID={EditFlagID}
      />
    </div>
  );
};

export default ChatList;